<template>
<div class="chapter">
<div class="inner_page">
<p class="ChapTitle"><a id="HLD7"></a>Donut Shop</p>
<p class="mhead">Fabric Requirements and Cutting</p>
<p class="fig"><img alt="" src="images/pg13a.jpg"/></p>
<p class="fig"><img alt="" src="images/pg13.jpg"/></p>
<p class="fig"><img alt="" src="images/pg13b.jpg"/></p>
<p class="ph1">Make the Block</p>
<p class="ph2">Sew the Inner Ring</p>
<p class="nl"><b>1.</b> Sew piece B to the bottom of piece A.</p>
<p class="nl"><b>2.</b> Sew piece C to the right side of the block.</p>
<p class="nl"><b>3.</b> Sew piece D to the top of the block.</p>
<p class="nl"><b>4.</b> Sew piece E to the left side of the block. <i>figure a</i></p>
<p class="fig"><img alt="" src="images/pg14a.jpg"/></p>
<p class="ph2">Add the Background Ring</p>
<p class="nl"><b>1.</b> Sew piece F to the bottom of the block.</p>
<p class="nl"><b>2.</b> Sew piece G to the right side of the block.</p>
<p class="nl"><b>3.</b> Sew piece H to the top of the block.</p>
<p class="nl"><b>4.</b> Sew piece I to the left side of the block. <i>figure b</i></p>
<p class="fig"><img alt="" src="images/pg14b.jpg"/></p>
<p class="ph2">ALTERNATE IDEAS</p>
<p class="fig"><img alt="" src="images/pg14d.jpg"/></p>
<p class="fig"><img alt="" src="images/pg14c.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_chapter05.vue?7e86a444